import { useEffect, useState } from "react";
import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import { debounce } from "lodash";
import PlanVerificationDetails from "../../../components/PlanVerificationDetails/PlanVerificationDetails";

const PlanVerificationDetailsPage = ({ defaultActiveTab = 0 }) => {
    const [showbreadCrumb, setShowBreadCrumb] = useState(() => {
        const storedValue = sessionStorage.getItem("header-footer");
        return storedValue !== null ? JSON.parse(storedValue) : true;
    });

    // Create a debounced setter function
    const debouncedSetHeaderFooterEnabled = debounce((value) => {
        setShowBreadCrumb(value);
    }, 100);

    const tabData = [
        {
            header: "Plan Verification Details",
        },
        {
            header: "Plan Generator",
        },
        {
            header: "Documents",
        },
        {
            header: "Corrections",
        },
        {
            header: "Verification",
        },
    ];

        // Use the debounced function
        useEffect(() => {
            const storedValue = sessionStorage.getItem("header-footer");
            if (storedValue !== null) {
                debouncedSetHeaderFooterEnabled(JSON.parse(storedValue));
            }
        }, [debouncedSetHeaderFooterEnabled]);

    const capitalizeFirstLetter = (string) => {
        return string
            ? string
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")
            : "";
    };

    const [tab, setTab] = useState(
        capitalizeFirstLetter(
            tabData[Number(defaultActiveTab)].header.toLowerCase()
        )
    );

    const [navigationItems, setNavigationItems] = useState([
        {
            label: "Annual Emission Verification",
            url: "",
            navId: "annual_emission_Verification_navId",
        },
        { label: "Plan Verification", url: "/plan-verification", navId: "plan_navId" },
        { label: `${tab}`, url: "", navId: `${tab.replace(" ", "_")}_navId` },
    ]);

    const handleTabChange = (tab) => {
        setTab(tab);
        let tempNavItems = navigationItems.splice(0, 2);

        tempNavItems.push({
            label: `${capitalizeFirstLetter(tab)}`,
            url: "",
            navId: `${tab.replace(" ", "_")}_navId`,
        });

        if (tempNavItems) {
            setNavigationItems(tempNavItems);
        }
    };

    const handleSubTabChange = (tab) => {
        let tempNav = [...navigationItems];
        if (tempNav[3] === undefined) {
            tempNav.push({
                label: `${capitalizeFirstLetter(tab)}`,
                url: "",
            });
        } else {
            tempNav[3] = {
                label: `${capitalizeFirstLetter(tab)}`,
                url: "",
            };
        }
        setNavigationItems(tempNav);
    };

    return (
        <>
            <div className="m-4 details-container">
                <div className="actions-top">
                {showbreadCrumb && <BreadCrumb items={navigationItems} />}
                </div>

                <div>
                    <PlanVerificationDetails
                        activeTab={defaultActiveTab}
                        onTabChange={handleTabChange}
                        handleSubTabChange={handleSubTabChange}
                    />
                </div>
            </div>
        </>
    );
};

export default PlanVerificationDetailsPage;